var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { normalize } from "@seedao/sns-namehash";
import { isSafe as isa, safe as s } from "@seedao/sns-safe";
import { resolve as r, resolves as rs, name as n, names as ns, tokenId as t, } from "@seedao/sns-api";
import { BASE_REGISTRAR_ADDR, PUBLIC_RESOLVER_ADDR, RPC, SAFE_HOST, INDEXER_HOST, } from "./builtin";
var sns;
(function (sns_1) {
    // sns to address
    // parameter 'sns' example: 'abc.seedao' 'sub.abc.seedao'
    function resolve(sns, rpc) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _r(sns, SAFE_HOST, INDEXER_HOST, rpc !== null && rpc !== void 0 ? rpc : RPC, PUBLIC_RESOLVER_ADDR)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
    sns_1.resolve = resolve;
    function _r(sns, safeHost, indexerHost, rpc, publicResolver) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, ok, name, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (sns.length == 0) {
                            return [2 /*return*/, "0x0000000000000000000000000000000000000000"]; // sns is empty
                        }
                        _a = normalize(sns), ok = _a[0], name = _a[1];
                        _b = !ok;
                        if (_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, isa(name, safeHost)];
                    case 1:
                        _b = !(_c.sent());
                        _c.label = 2;
                    case 2:
                        // checking safe
                        if (_b) {
                            return [2 /*return*/, "0x0000000000000000000000000000000000000000"]; // SNS is not safe
                        }
                        return [4 /*yield*/, r(name, indexerHost, rpc, publicResolver)];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    }
    sns_1._r = _r;
    // address to sns
    // return value example: 'abc.seedao' 'sub.abc.seedao'
    function name(addr, rpc) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _n(addr, SAFE_HOST, INDEXER_HOST, rpc !== null && rpc !== void 0 ? rpc : RPC, PUBLIC_RESOLVER_ADDR)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
    sns_1.name = name;
    function _n(addr, safeHost, indexerHost, rpc, publicResolver) {
        return __awaiter(this, void 0, void 0, function () {
            var name;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (addr.length == 0) {
                            return [2 /*return*/, ""]; // address is empty
                        }
                        return [4 /*yield*/, n(addr, indexerHost, rpc, publicResolver)];
                    case 1:
                        name = _a.sent();
                        if (name.length == 0) {
                            return [2 /*return*/, ""]; // address has no sns
                        }
                        return [4 /*yield*/, isa(name, safeHost)];
                    case 2:
                        if (!(_a.sent())) {
                            return [2 /*return*/, ""]; // SNS is not safe
                        }
                        return [2 /*return*/, name];
                }
            });
        });
    }
    sns_1._n = _n;
    // sns array to address array
    // parameter 'snssnsArr' example: ['abc.seedao', 'sub.abc.seedao']
    function resolves(snsArr, rpc) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _rs(snsArr, SAFE_HOST, INDEXER_HOST, rpc !== null && rpc !== void 0 ? rpc : RPC, PUBLIC_RESOLVER_ADDR)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
    sns_1.resolves = resolves;
    function _rs(snsArr, safeHost, indexerHost, rpc, publicResolver) {
        return __awaiter(this, void 0, void 0, function () {
            var names, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (snsArr.length == 0) {
                            return [2 /*return*/, []]; // sns array is empty
                        }
                        names = snsArr.map(function (sns) {
                            // normalize
                            var _a = normalize(sns), ok = _a[0], nSNS = _a[1];
                            return ok ? nSNS : "";
                        });
                        _a = rs;
                        return [4 /*yield*/, s(names, safeHost)];
                    case 1: return [4 /*yield*/, _a.apply(void 0, [_b.sent(), indexerHost, rpc, publicResolver])];
                    case 2: 
                    // checking safe and call resolves
                    return [2 /*return*/, _b.sent()];
                }
            });
        });
    }
    sns_1._rs = _rs;
    // address array to sns array
    // return value example: ['abc.seedao', 'sub.abc.seedao']
    function names(addrArr, rpc) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _ns(addrArr, SAFE_HOST, INDEXER_HOST, rpc !== null && rpc !== void 0 ? rpc : RPC, PUBLIC_RESOLVER_ADDR)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
    sns_1.names = names;
    function _ns(addrArr, safeHost, indexerHost, rpc, publicResolver) {
        return __awaiter(this, void 0, void 0, function () {
            var names;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (addrArr.length == 0) {
                            return [2 /*return*/, []]; // address array is empty
                        }
                        return [4 /*yield*/, ns(addrArr, indexerHost, rpc, publicResolver)];
                    case 1:
                        names = _a.sent();
                        return [4 /*yield*/, s(names, safeHost)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
    sns_1._ns = _ns;
    // get sns's ERC721 token id
    function tokenId(sns, rpc) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _t(sns, SAFE_HOST, INDEXER_HOST, rpc !== null && rpc !== void 0 ? rpc : RPC, BASE_REGISTRAR_ADDR)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
    sns_1.tokenId = tokenId;
    function _t(sns, safeHost, indexerHost, rpc, BaseRegistrar) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, ok, name, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (sns.length == 0) {
                            return [2 /*return*/, ""]; // sns is empty
                        }
                        _a = normalize(sns), ok = _a[0], name = _a[1];
                        _b = !ok;
                        if (_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, isa(name, safeHost)];
                    case 1:
                        _b = !(_c.sent());
                        _c.label = 2;
                    case 2:
                        // checking safe
                        if (_b) {
                            return [2 /*return*/, ""]; // SNS is not safe
                        }
                        return [4 /*yield*/, t(name, indexerHost, rpc, BaseRegistrar)];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    }
    sns_1._t = _t;
})(sns || (sns = {}));
export default sns;
export * as builtin from "./builtin";
